/* A titled block on a dashboard: the bordered card that holds a chart, a table
   or a list.

   `SectionLabel` is duplicated from GrievancePieces rather than imported from
   it — the kit must not depend on a feature module, or every dashboard inherits
   the grievance module's imports. GrievancePieces keeps its own copy until that
   screen is moved onto the kit. */
import { cn } from "../../utils/tailwindUtils";

export const SectionLabel = ({ children }) => (
    <p className="mb-1.5 text-[11px] font-bold uppercase tracking-wide text-muted-foreground">
        {children}
    </p>
);

/* `Icon` is optional. The Home dashboard's sections are icon-led — the icon is
   how people find a block on a page of fifteen — so dropping it on the way to
   the kit would have cost information, not just decoration. Screens without
   one are unchanged. */
export const DashboardSection = ({ Icon, iconClass, title, action, className, children }) => (
    <div className={cn("rounded-lg border border-gray-200 p-3.5 dark:border-gray-700", className)}>
        {/* The action sits on the label's baseline, so a section with a "view
            all" link keeps the same header height as one without. */}
        {(title || action) && (
            <div className="flex items-start justify-between gap-3">
                {title ? (
                    <SectionLabel>
                        {Icon ? (
                            <span className="flex items-center gap-1.5">
                                <Icon className={cn("h-3.5 w-3.5", iconClass || "text-sidebar-primary")} />
                                {title}
                            </span>
                        ) : title}
                    </SectionLabel>
                ) : <span />}
                {action && <div className="-mt-1 shrink-0">{action}</div>}
            </div>
        )}
        {children}
    </div>
);

/* Side-by-side sections that stack on a phone. Anything narrower than a laptop
   gets one column — two half-width distribution charts are unreadable on a
   phone, and that is the width most of this product is checked on. */
export const SectionGrid = ({ columns = 2, className, children }) => (
    <div
        className={cn(
            "grid grid-cols-1 gap-4",
            columns === 3 ? "lg:grid-cols-3" : "lg:grid-cols-2",
            className,
        )}
    >
        {children}
    </div>
);
